export default "__VITE_ASSET__qoZBlZy6__"